// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typePickChangeBody = {
  poolId: string;
  entryId: string;
  roundId: string;
  eventId: string;
  teamId: string;
  acceptsPendingSpread?: boolean | null;
};

export type typePickChangeOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | { accepted: boolean };
};

export type typePickChangeOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typePickChangeOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typePickChangeOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaPickChangeBody = {
  type: "object",
  properties: {
    poolId: { type: "string", maxLength: 3000, minLength: 1 },
    entryId: { type: "string", maxLength: 3000, minLength: 1 },
    roundId: { type: "string", maxLength: 3000, minLength: 1 },
    eventId: { type: "string", maxLength: 3000, minLength: 1 },
    teamId: { type: "string", maxLength: 3000, minLength: 1 },
    acceptsPendingSpread: { oneOf: [{ type: "boolean" }, { enum: [null] }] },
  },
  required: ["poolId", "entryId", "roundId", "eventId", "teamId"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createPickChange(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaPickChangeBody);
  }

  return async function postPickChange(
    payload: typePickChangeBody,
  ): Promise<typePickChangeOutput200 | typePickChangeOutput400> {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postPickChange" failed before calling the network. #d519375a7fff`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#d519375a7fff" },
        },
        data: null,
      } as typePickChangeOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/pick/change`,
      httpMethod: "POST",
      options,
    })) as typePickChangeOutput200 | typePickChangeOutput400;
  };
}
